/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpServersGetUsageImpact } from "../funcs/mcpServersGetUsageImpact.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { McpServerUsageImpact } from "../models/components/mcpserverusageimpact.js";
import {
  GetMcpServerUsageImpactRequest,
  GetMcpServerUsageImpactSecurity,
} from "../models/operations/getmcpserverusageimpact.js";
import { unwrapAsync } from "../types/fp.js";
export type McpServerUsageImpactQueryData = McpServerUsageImpact;

export function prefetchMcpServerUsageImpact(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetMcpServerUsageImpactRequest,
  security?: GetMcpServerUsageImpactSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMcpServerUsageImpactQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMcpServerUsageImpactQuery(
  client$: GramCore,
  request: GetMcpServerUsageImpactRequest,
  security?: GetMcpServerUsageImpactSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<McpServerUsageImpactQueryData>;
} {
  return {
    queryKey: queryKeyMcpServerUsageImpact({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function mcpServerUsageImpactQueryFn(
      ctx,
    ): Promise<McpServerUsageImpactQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpServersGetUsageImpact(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMcpServerUsageImpact(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpServers", "getUsageImpact", parameters];
}
